import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  environmentName: 'prod',
  apiUrl: 'https://cct-qa-int.dcsa.aws.alight.com/',
  angularBaseUrl: 'https://cache-cct-qa.ap.alight.com/',
  version: require('../../package.json').version,
  GENESYS_CLOUD_CLIENT_ID: '440553c8-cd8f-4222-9552-739752029345',
  REDIRECT_URI: 'https://cache-cct-qa.ap.alight.com/',
  LOGOUT_REDIRECT_URI: 'https://cache-cct-qa.ap.alight.com/log-out',
  logger: {
    level: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.DEBUG,
  },
};
// export const prodEnvirnoment = environment;
